import React from 'react';
import classNames from "classnames";


import {IconProps} from "../icons";


import './InTextLabel.css';


export interface InvitePeopleProps {
    className?: string;
    text: string;
    type: 'success' | 'danger' | 'neutral' | 'info' | 'warning';
    size?: "sm" | "md" | "lg"
    Icon?: React.ComponentType<IconProps>;
}

export const InTextLabel = (
    {
        className,
        type,
        text,
        size,
        Icon
    }: InvitePeopleProps
) => {
    return (
        <span className={
            classNames({
                "InTextLabel": true,
                [className!]: className,
                "title-medium InTextLabel--lg": size === "lg",
                "body-large InTextLabel--sm": size ==="sm",
                "InTextLabel--success": type === 'success',
                "InTextLabel--danger": type === 'danger',
                "InTextLabel--neutral": type === 'neutral',
                "InTextLabel--info": type === 'info',
                "InTextLabel--warning": type === 'warning',
            })
        }>
			{Icon && <Icon size={20} className={"InTextLabel__icon"}/>}{text}
		</span>
    )
}